__turbopack_context__.v({
  "bottomLinksPanel": "about-us-module__aFJ6Iq__bottomLinksPanel",
  "bottomLinksPanelItem": "about-us-module__aFJ6Iq__bottomLinksPanelItem",
  "fixedHeaderHeightFudge": "about-us-module__aFJ6Iq__fixedHeaderHeightFudge",
  "partnerLogoContainer": "about-us-module__aFJ6Iq__partnerLogoContainer",
  "partnerLogosContainer": "about-us-module__aFJ6Iq__partnerLogosContainer",
  "teamContainer": "about-us-module__aFJ6Iq__teamContainer",
  "teamMember": "about-us-module__aFJ6Iq__teamMember",
  "teamMemberDetails": "about-us-module__aFJ6Iq__teamMemberDetails",
  "teamMemberFunImage": "about-us-module__aFJ6Iq__teamMemberFunImage",
  "teamMemberImage": "about-us-module__aFJ6Iq__teamMemberImage",
  "teamMemberLinkedIn": "about-us-module__aFJ6Iq__teamMemberLinkedIn",
  "teamMemberShadow": "about-us-module__aFJ6Iq__teamMemberShadow",
});
